<div class="map_box_container">
  <div class="map_box" *ngIf="zoneInfo">
    <app-home-search-bar type="sip" [status]="status"
      (searchWithParams)="searchWithParams($event)"></app-home-search-bar>
    <div class="heading-s-bold" *ngIf="zoneInfo.drivers?.length">{{(zoneInfo.drivers.length) + ' ' +
      ('home.vehicles'
      | translate)}}</div>
    <app-google-map-general *ngIf="currentUser" [user]="currentUser"
      [searchParams]="searchParams"></app-google-map-general>
  </div>
</div>